import { render, staticRenderFns } from "./EmotionWheelConfig.vue?vue&type=template&id=67881a0e"
import script from "./EmotionWheelConfig.vue?vue&type=script&lang=js"
export * from "./EmotionWheelConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67881a0e')) {
      api.createRecord('67881a0e', component.options)
    } else {
      api.reload('67881a0e', component.options)
    }
    module.hot.accept("./EmotionWheelConfig.vue?vue&type=template&id=67881a0e", function () {
      api.rerender('67881a0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/EmotionWheelConfig.vue"
export default component.exports